<template>
    <div :class="clsPrefix">
        <div :class="classNames('toolbar')">
            <slot />
            <SearchInput
                v-if="hasField('search')"
                :class="classNames(['filter', 'filter--search'])"
                :placeholder="$t('misc.search')"
                @change="onSearch"
            />
            <div :class="classNames('spacer')" />
            <DateInput
                v-if="hasField('date')"
                ref="dateInputRes"
                v-model="date"
                :class="classNames(['filter', 'filter--date'])"
                :max-date="new Date()"
                @change="onDateChange"
            >
                <template #value-text="{ valueText }">
                    {{ valueText.monthLoc }} {{ valueText.year }}
                </template>
            </DateInput>
        </div>
    </div>
</template>

<script>
import { SearchInput, DateInput } from '@speechki-frontend/shared/ui/forms';
import { wrapInArray } from '@speechki-frontend/shared/helpers/functions';

export default {
    name: 'StatisticFilters',
    components: {
        SearchInput,
        DateInput,
    },
    props: {
        clsPrefix: {
            type: String,
            default: 'statistic-filters',
        },
        schema: {
            type: Array,
            default: () => ['date'],
        },
        modelValue: {
            type: Object,
            default: () => ({}),
        },
    },
    emits: ['search', 'update:modelValue', 'filter'],
    data() {
        const date = new Date();

        return {
            date,
            values: {
                month: null, //date.getMonth(),
                year: null, //date.getFullYear()
            },
        };
    },
    computed: {
        dateText() {
            const { month, year } = this.values;
            return `${month} ${year}`;
        },
    },
    methods: {
        hasField(name) {
            return this.schema.includes(name);
        },
        classNames(list = '') {
            return wrapInArray(list).map((name) => `${this.clsPrefix}__${name}`);
        },
        onSearch(value) {
            this.$emit('search', value);
        },
        onChange(field, value) {
            this.$emit('update:modelValue', this.values);
            this.$emit('filter', { [field]: value });
        },
        onDateChange({ year, month }) {
            this.values = {
                ...this.values,
                ...{ year, month },
            };
            this.$emit('filter', { year, month });
            this.date = new Date(year, --month, 1);
            this.$refs.dateInputRes.hidePicker();
        },
    },
};
</script>

<style lang="scss" src="./StatisticFilters.scss"></style>
